// @ts-ignore
import scssVariablesSource from '@/scss/_app.scss'
import {SCSSVariables} from '@/js/@types/scssVariables'

const scssVariables: SCSSVariables = {
    ...scssVariablesSource
}

export default scssVariables
